<div class="row page-header">
    <div class="col-12">
        <h1>Fab Board <small>(Beta) Fabrication production schedule</small></h1>
    </div>
</div>

<div [hidden]="isInitialLoading">
    <div class="row action-toolbar">
        <div class="col-12">
            <form class="form-inline">
                <div class="form-group me-3 mb-2">
                    <label class="me-2" for="fabJobSelect">Job</label>
                    <wj-combo-box
                        id="fabJobSelect"
                        name="fabJobSelect"
                        [(ngModel)]="selectedJobId"
                        [itemsSource]="jobOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="false"
                        (selectedIndexChanged)="onJobChanged()"
                        style="width: 22rem"
                    ></wj-combo-box>
                </div>
                <action-toolbar-count [grid]="grid"></action-toolbar-count>
                <action-toolbar-buttons
                    [grid]="grid"
                    [canEdit]="canEdit"
                    [showAdd]="true"
                    [showEdit]="true"
                    [showDelete]="!showArchived"
                    [deleteText]="'Archive'"
                ></action-toolbar-buttons>
                @if (showArchived && canEdit) {
                    <button
                        type="button"
                        class="btn btn-sm btn-secondary mb-2 me-2"
                        (click)="restoreSelected()"
                        [disabled]="!canRestoreSelected"
                    >
                        Restore
                    </button>
                    <button
                        type="button"
                        class="btn btn-sm btn-secondary mb-2 me-2"
                        (click)="permanentDeleteSelected()"
                        [disabled]="!grid.hasItemSelected"
                    >
                        Permanent Delete
                    </button>
                }
                @if (canPlaceHold) {
                    <button type="button" class="btn btn-sm btn-secondary mb-2 me-2" (click)="placeOnHold()">{{ holdActionLabel }}</button>
                    <button type="button" class="btn btn-sm btn-secondary mb-2 me-2" (click)="releaseHold()">Release hold</button>
                }
                <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                <grid-export [grid]="mainGrid" [name]="'FabBoard'"></grid-export>
                <button
                    type="button"
                    class="btn btn-sm btn-secondary mb-2 ms-2"
                    (click)="toggleShowArchived()"
                    [class.btn-primary]="showArchived"
                    title="Toggle showing archived and finished pieces"
                >
                    <i class="fas" [class.fa-eye]="!showArchived" [class.fa-eye-slash]="showArchived"></i>
                    {{ showArchived ? 'Hide Archived' : 'Show Archived' }}
                </button>
            </form>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <grid-column-group [grid]="grid"></grid-column-group>
            <wj-flex-grid
                id="mainGrid"
                #mainGrid
                appAutoSize
                (initialized)="grid.initialize(mainGrid)"
                (destroy)="grid.destroy()"
                [itemsSource]="grid.view"
            >
                <wj-flex-grid-filter></wj-flex-grid-filter>
                <wj-flex-grid-column [header]="'Job'" [binding]="'jobDisplayName'" [width]="220" [visible]="false"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'DWG #'" [binding]="'markCode'" [width]="90"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Name'" [binding]="'name'" [width]="'*'" [minWidth]="140"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Scope'" [binding]="'scope'" [width]="120"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Description'" [binding]="'description'" [width]="260" [minWidth]="160"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Drawings/Photos'" [binding]="'drawingFileNames'" [width]="200" [isReadOnly]="true"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Qty'" [binding]="'quantity'" [width]="65" [align]="'center'"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Is Stock'" [binding]="'isStock'" [width]="80" [dataMap]="yesNoMap"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Current Step'" [binding]="'currentStepName'" [width]="180"></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'% Complete'"
                    [binding]="'percentComplete'"
                    [width]="90"
                    [format]="'p0'"
                    [align]="'center'"
                ></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Next Step'" [binding]="'nextStepName'" [width]="160"></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Next Planned'"
                    [binding]="'nextStepPlannedDate'"
                    [width]="100"
                    [format]="'yyyy-MM-dd'"
                ></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Risk'" [binding]="'riskLevel'" [width]="90"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Days Late'" [binding]="'daysLate'" [width]="80" [align]="'center'"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Hold'" [binding]="'holdReasonName'" [width]="140"></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Required On Site'"
                    [binding]="'requiredOnSiteDate'"
                    [width]="110"
                    [format]="'yyyy-MM-dd'"
                ></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Priority'" [binding]="'priority'" [width]="80" [align]="'center'"></wj-flex-grid-column>
                @for (step of activeSteps; track step.id) {
                    <wj-flex-grid-column
                        [header]="stepHeader(step)"
                        [binding]="stepBinding(step)"
                        [width]="120"
                        [format]="'yyyy-MM-dd'"
                    ></wj-flex-grid-column>
                }
            </wj-flex-grid>
        </div>
    </div>
</div>
